// VrBex requires the platform to support a different type of site resolution (aka basepath resolution)
// Basepath : one domain, with a /language-locale/ subfolder (aka basepath), representing the PoSa.
// E.g.: vrbo.com/en-gb

export const BASEPATH = '/:basepath?';
export const VRBO_BASEPATH = '/:basepath([a-z]{2}-[a-z]{2})?';
